module.exports = __webpack_public_path__ + "img/image.f0d4e868.svg";